import { InputGroup, InputGroupBreak } from '@equifinance/shared';
import styled from 'styled-components';

export const HighlightInputGroup = styled.div` ${({ theme }) => `
  background: ${theme.colours.neutral[9]};
  box-shadow: inset 0px 8px 8px -4px rgba(0,0,0,0.05);
  margin-left: ${theme.padding[8]};
  margin-right: ${theme.padding[8]};

  ${InputGroup} {
    margin-left: -${theme.padding[8]};
    margin-right: -${theme.padding[8]};
  }

  ${InputGroupBreak} {
    margin-left: calc(${theme.padding[9]} + ${theme.padding[2]});
    margin-right: calc(${theme.padding[9]} + ${theme.padding[2]});
  }
`}`;

export const HighlightInputGroupSecondary = styled(HighlightInputGroup)` ${({ theme }) => `
  background: ${theme.colours.tertiary[7]};
  box-shadow: none;
  border-radius: ${theme.borderRadius[2]};
`}`;
